export default __webpack_public_path__ + "static/media/image7.9bb44ed7.png";